import React, { useRef, useEffect } from "react";
import VectorCanvas from "./VectorCanvas";
import "../Canvas.css";

const Canvas = ({ vectorCanvasRef, setInputValues }) => {
    const canvasRef = useRef(null);
    //const [setUpdateKey] = useState(0); // Trigger re-renders
    const lastInputValues = useRef(null); // Store last values to prevent unnecessary re-renders

    useEffect(() => {
        const canvas = canvasRef.current;

        if (canvas && !vectorCanvasRef.current) {
            // Initialize VectorCanvas only once
            vectorCanvasRef.current = new VectorCanvas(canvas);
            vectorCanvasRef.current.draw();
            console.log("VectorCanvas initialized:", vectorCanvasRef.current);
        }

        const originalSetBasis = vectorCanvasRef.current.setBasis;
        vectorCanvasRef.current.setBasis = (...args) => {
            originalSetBasis.apply(vectorCanvasRef.current, args);
            //setUpdateKey(prev => prev + 1); // Force update when basis changes
        };

        const updateInputs = () => {
            if (vectorCanvasRef.current) {
                const { basisVectors } = vectorCanvasRef.current.draw();
                const newValues = [basisVectors[0].x, basisVectors[1].x, basisVectors[0].y, basisVectors[1].y];
    
                if (!lastInputValues.current || JSON.stringify(lastInputValues.current) !== JSON.stringify(newValues)) {
                    lastInputValues.current = newValues;
                    setInputValues(newValues);
                }
            }
            requestAnimationFrame(updateInputs);
        };
        requestAnimationFrame(updateInputs);

    }, [vectorCanvasRef, setInputValues]);

    return <canvas ref={canvasRef} className="canvas" width={800} height={600} />;
};

export default Canvas;
